import React from 'react';

import {
  Button,
  Box,
  Flex,
  Text,
  Tag,
  Image,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
} from '@chakra-ui/react';
import { useState } from 'react';

import Card from 'components/card/Card';

const ImagePreview: React.FC<{
  fetchImg?: any;
  isOpen?: any;
  onOpen?: any;
  onClose?: any;
  values?: any;
  setValues?: any;
  selectedCardIndex?: any;
  handleBackground?: any;
  truncateTex?: any;
}> = ({
  fetchImg,
  isOpen,
  onOpen,
  onClose,
  values,
  setValues,
  selectedCardIndex,
  handleBackground,
  truncateTex,
}) => {
  let lightBlue = useColorModeValue('#3311db5c', '#3311db5c');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay />
      <ModalContent
        backgroundColor="#ffffff"
        containerProps={{ zIndex: 999999 }}
      >
        <ModalCloseButton color={'black'} />
        <ModalBody>
          <Flex
            flexDirection={{ base: 'column', lg: 'row' }}
            // justifyContent="Center"
            alignItems="Center"
            height="100vh"
            background="#ffffff" // Adjust the opacity as needed
          >
            <Box w={{ base: '100%', lg: '80%' }} m={0} pt={'15px'}>
              {/* Top Content */}
              <Text
                fontSize={'1.25rem'}
                color={'#1B2559'}
                pb={'15px'}
                fontWeight={'700'}
              >
                Preview
              </Text>
              <Image
                borderRadius={'20px'}
                src={fetchImg.gasAssetImage}
                alt="Preview"
                width={{ base: '100%', lg: '95%' }}
                height={{ base: '85%', md: '90%', lg: '80%' }}
              />
            </Box>
            <Box m={0} w={{ base: '100%', lg: '30%' }} p={0}>
              <Card
                borderRadius={'none'}
                boxShadow={'5px 5px 20px #c5c5c5'}
                m={0}
                p={5}
              >
                <Text fontSize={'1.25rem'} color={'#1B2559'} fontWeight={'700'}>
                  Title
                </Text>
                <Text fontSize={'1rem'} style={{ whiteSpace: 'pre-wrap' }}>
                  {fetchImg?.temp?.tempTitle}
                </Text>
                <Text fontSize={'1.25rem'} color={'#1B2559'} fontWeight={'700'}>
                  Story Line
                </Text>

                <Text fontSize={'1rem'} whiteSpace="pre-wrap">
                  {fetchImg.temp?.tempStoryLine}
                </Text>
                {/* </Box> */}
                <Flex
                  direction="row"
                  p="12px"
                  wrap="wrap"
                  bg="transparent"
                  // border='1px solid'
                  // borderColor={borderColor}
                  // borderRadius='16px'
                  // _focus={{ borderColor: 'teal.300' }}
                  minH="30px"
                  maxH="300px !important"
                  h="stretch"
                  cursor="text"
                  style={{ overflowY: 'auto' }}
                >
                  <p
                    style={{
                      marginLeft: '-13px',
                      fontSize: '1.25rem',
                      color: '#1B2559',
                      fontWeight: '700',
                    }}
                  >
                    Skills:
                  </p>
                  <Text>
                    {fetchImg?.skills?.length > 0 &&
                      fetchImg.skills.map((skill: string, index: number) => (
                        <Tag
                          key={index}
                          fontSize="xs"
                          h="25px"
                          mb="6px"
                          me="6px"
                          borderRadius="12px"
                          marginLeft={'4px'}
                          variant="solid"
                          bg={lightBlue}
                        >
                          <p style={{ color: 'black', fontSize: '14px' }}>
                            {skill}
                          </p>
                        </Tag>
                      ))}
                  </Text>
                </Flex>
                <Button
                  bg="#3311db"
                  _hover={{ bg: '#3311db' }}
                  color="#fff"
                  fontSize={{ base: '14px', lg: '16px' }}
                  // mt={{ base: 2, lg: 0 }}
                  mt={'20px'}
                  w={'100%'}
                  // float={"right"}
                  onClick={() => handleBackground(fetchImg, fetchImg.i)}
                >
                  <Text>
                    {selectedCardIndex === fetchImg.i
                      ? 'Selected'
                      : 'Click to select'}
                  </Text>
                </Button>
              </Card>
            </Box>
            <Box mt={4} alignSelf="flex-end">
              {' '}
              {/* Align the button to the right */}
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ImagePreview;
